import { render, staticRenderFns } from "./PricingCards.vue?vue&type=template&id=4b1dcbb1"
import script from "./PricingCards.vue?vue&type=script&lang=js"
export * from "./PricingCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports